import { ComboOption } from 'components/ui/combobox'

export const ONBOARDING_INDUSTRY_OPTIONS: ComboOption[] = [
  {
    id: 1,
    value: 'Agency or Consulting',
    label: 'onboarding_questionnaire_selection_agency',
  },
  {
    id: 2,
    value: 'Ecommerce or Retail',
    label: 'onboarding_questionnaire_selection_ecommerce',
  },
  {
    id: 3,
    value: 'Education or Online Learning',
    label: 'onboarding_questionnaire_selection_education',
  },
  {
    id: 4,
    value: 'Finance, Banking or Insurance',
    label: 'onboarding_questionnaire_selection_finance',
  },
  {
    id: 5,
    value: 'Healthcare or Medical',
    label: 'onboarding_questionnaire_selection_healthcare',
  },
  {
    id: 6,
    value: 'Legal Services',
    label: 'onboarding_questionnaire_selection_legal',
  },
  {
    id: 7,
    value: 'Manufacturing or Industrial',
    label: 'onboarding_questionnaire_selection_manufacturing',
  },
  {
    id: 8,
    value: 'Media Publishing',
    label: 'onboarding_questionnaire_selection_media_publishing',
  },
  {
    id: 9,
    value: 'Nonprofit or Government',
    label: 'onboarding_questionnaire_selection_nonprofit',
  },
  {
    id: 10,
    value: 'Real Estate',
    label: 'real_estate',
  },
  {
    id: 11,
    value: 'Technology or Software',
    label: 'onboarding_questionnaire_selection_technology',
  },
  {
    id: 12,
    value: 'Travel or Hospitality',
    label: 'onboarding_questionnaire_selection_travel',
  },
  {
    id: 13,
    value: 'Other',
    label: 'other_industry',
  },
]
